<div class='container news-page' *ngIf='data'>
  <div class="news-page-wrapper">

    <div class="news-page__image">
      <app-picture [data]='data.previewImage.value'></app-picture>
    </div>

    <div class="news-page__content">
      <div class="details">

        <div class="news-page__header">
            <app-heading>{{data.title.value}}</app-heading>
            <div class="news-page__back">
              <a class="back" [routerLink]='data.newsOverviewLink' [attr.aria-label]="'newsDetails.BackLink.Text' | translate">
                {{ 'newsDetails.BackLink.Text' | translate }}
              </a>
            </div>
        </div>

        <div class="details__top">
          <div class="details__date">
            <span class="date">{{ data.publishDate.value }}</span>
          </div>
          <div class="details__social">
            <span>{{ 'social.Label' | translate }}</span>
            <a [attr.aria-label]="'social.FacebookShare' | translate" href="https://www.facebook.com/sharer/sharer.php?u={{ url }}" target="_blank">
              <svg class="details__social-icon" xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27">
                <path fill-rule="evenodd" d="M15.79 27V16.965h3.537l.53-3.911h-4.068v-2.497c0-1.132.33-1.904 2.036-1.904L20 8.652V5.154C19.624 5.107 18.332 5 16.83 5c-3.136 0-5.283 1.823-5.283 5.17v2.884H8v3.91h3.547V27H0V0h27v27H15.79z"/>
              </svg>
            </a>
            <a [attr.aria-label]="'social.LinkedinShare' | translate" href="https://www.linkedin.com/sharing/share-offsite/?url={{ url }}" target="_blank">
              <svg class="details__social-icon" xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27">
                <path fill-rule="evenodd" d="M0 0h27v27H0V0zm22.32 22.085v-6.63c0-3.256-.703-5.76-4.507-5.76-1.828 0-3.054 1.003-3.555 1.954h-.052V9.996h-3.601v12.09h3.752v-5.98c0-1.578.299-3.106 2.254-3.106 1.928 0 1.952 1.804 1.952 3.206v5.879h3.757zM6.368 8.343a2.18 2.18 0 1 0-.003-4.359 2.18 2.18 0 0 0 .003 4.36zm1.88 13.742V9.995H4.486v12.09h3.76z"/>
              </svg>
            </a>
          </div>
        </div>

        <div *ngIf="data.description && data.description.value" class="rte details__text" [innerHTML]='data.description.value'></div>
      </div>
    </div>

    <app-panels *ngIf="data.panels && data.panels.value"  [items]="data.panels.value"></app-panels>

    <div class="news-page__bottom-content">
      <div class="news-page__date" *ngIf="data.lastUpdatedDateString">{{ 'newsDetails.LastUpdated' | translate }} {{ data.lastUpdatedDateString }}</div>
    </div>
  </div>
</div>
